import { isArrayOf, isBoolean, isString } from "@/fx/data-helpers/misc";

export type Address = {
  street:  string;
  city:    string;
  state:   string;
  zipCode: string;
};
export const isAddress = (obj: any): obj is Address => {
  return !!obj && typeof obj === 'object'

    && isString(obj.street)
    && isString(obj.city)
    && isString(obj.state)
    && isString(obj.zipCode);
};

export type Distributor = {
  name:       string;
  sapId:      string;
  address:    Address;
  locations?: Distributor[];
};
export const isDistributor = (obj: any): obj is Distributor => {
  return !!obj && typeof obj === 'object'

    && isString(obj.name)
    && isString(obj.sapId)

    && isAddress(obj.address)

    && (obj.locations === undefined || isArrayOf(isDistributor)(obj.locations));
};

export type User = {
  firstName:    string;
  lastName:     string;
  emailAddress: string;
  active:       boolean;
  roles:        string[];
  distributors: Distributor[];
};
export const isUser = (obj: any): obj is User => {
  return !!obj && typeof obj === 'object'

    && isString (obj.firstName)
    && isString (obj.lastName)
    && isString (obj.emailAddress)
    && isBoolean(obj.active)

    && isArrayOf(isString     )(obj.roles)
    && isArrayOf(isDistributor)(obj.distributors);
};
